import React, {Component} from 'react';

class EmptyLayout extends Component {

    constructor(props) {

        super(props);

        this.eventEmitter = this.props.screenProps;

        let userId = (localStorage.getItem('userId') !== '4' && localStorage.getItem('userId') !== 4 ) ? localStorage.getItem('userId') : '';

        let accessToken = (localStorage.getItem('accessToken') !== '2y10zZGNPSgkYdTMPjSftoy7Au1mVtSaUfw273vZQx3iqVQmwM1TKGG' && localStorage.getItem('accessToken') !== '2y10zZGNPSgkYdTMPjSftoy7Au1mVtSaUfw273vZQx3iqVQmwM1TKGG' && localStorage.getItem('accessToken') !== '2y10zZGNPSgkYdTMPjSftoy7Au1mVtSaUfw273vZQx3iqVQmwM1TKGG') ? localStorage.getItem('accessToken') : '';

        this.state = {
            
            isAuthenticated : userId && accessToken ? true : false

        }

    }


    render() {

        const {isAuthenticated} = this.state;

        return (
            <div className="wrapper">
               {React.cloneElement(this.props.children, {eventEmitter : this.eventEmitter, data : isAuthenticated})}
            </div>
        )
    }
}
export default EmptyLayout;

